export default "/public/img/icon.88a8c05e.png";